//export default class Ecosystem {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.ecosystem');  
//   }
//}
//
//new Ecosystem();


import AOS from 'aos';
import 'aos/dist/aos.css'; 
import simpleParallax from 'simple-parallax-js';

document.addEventListener("DOMContentLoaded", () => {
    AOS.init();

    var image = document.querySelectorAll('.parallax-image')
    new simpleParallax(image, {
        orientation: 'up',
        overflow: true,
        delay: .6,
    });
});
